export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const GET_CHILD_DROPDOWN_OPTION = "GET_CHILD_DROPDOWN_OPTION";
export const TOGGEL_SIDEBAR = "TOGGEL_SIDEBAR";
export const GET_PAGE_RELOAD_FLAG = "GET_PAGE_RELOAD_FLAG";
export const ASSIGN_VALUE = "ASSIGN_VALUE";
export const ALERT_COMPONENT = "ALERT_COMPONENT";
export const BASIC_AUTH = "BASIC_AUTH";
export const FORM_VALUES = "FORM_VALUES";
export const REGISTRATION_RESPONSE_SAVE = "REGISTRATION_RESPONSE_SAVE";
export const TAB_HIDE_VALUES = "TAB_HIDE_VALUES";
export const SELECTED_TAB = "SELECTED_TAB";
export const WORKFLOW_FLAG = "WORKFLOW_FLAG";
export const RELATIONTYPE = "RELATIONTYPE";
export const SET_LOGIN = "SET_LOGIN";
export const SET_TRACKEDENTITYINSTANCE = "SET_TRACKEDENTITYINSTANCE";
export const SET_LOCATION = "SET_LOCATION";
export const SET_LANGUAGE_LIST = "SET_LANGUAGE_LIST";
export const SET_SHOW_HEADER = "SET_SHOW_HEADER";
export const SET_RESET_STATE = "SET_RESET_STATE";
